// extracted by mini-css-extract-plugin
module.exports = {"country":"countryWrapper-module--country--3lCVO","country__title":"countryWrapper-module--country__title--3-2Os"};